import RequestBuilder from 'Resources/RequestBuilder';
import type { MultiSelect } from 'App/components/ListView/ListViewRenderHelpers';
import openModal from 'App/services/Modal/Modal';

export default function closeActivities(rb: RequestBuilder, entity: string, multiSelect: MultiSelect) {
	openModal('MultiCloseActivityModal', {
		filters: rb,
		entityType: entity,
		multiSelect
	});
}
